import React from "react";
import {
  IcoMenu, IcoSearch, IcoX, IcoFolderPlus, IcoFolderUp, IcoUpload, IcoDownload,
} from "./Icons";

// Thanh trên cùng: nút mở trình đơn (màn hình hẹp), ô lọc theo tên và các
// thao tác với thư mục đang mở. Trên điện thoại các thao tác phụ xuống hàng
// thứ hai để nút "Tải lên" luôn nằm trong tầm tay.
export default function ActionBar({
  role, path,
  search, onSearch,
  onOpenNav,
  onCreate, onUploadImage, onUploadFolder, onDownload,
  loading = false,
  locked = false,
}) {
  const isAdmin = role === "admin";
  // Thư mục có mật khẩu mà chưa mở khóa: ẩn các thao tác với nội dung thư mục.
  const hasMore = !locked && (isAdmin || !!path);

  return (
    <header className="topbar">
      <button className="icon-btn ghost topbar-menu" onClick={onOpenNav} aria-label="Mở trình đơn">
        <IcoMenu size={20} />
      </button>

      <label className="search">
        <IcoSearch size={16} />
        <input
          type="text"
          placeholder="Lọc theo tên trong thư mục này…"
          value={search}
          onChange={(e) => onSearch(e.target.value)}
        />
        {search && (
          <button type="button" className="search-clear" onClick={() => onSearch("")} aria-label="Xóa nội dung lọc">
            <IcoX size={14} />
          </button>
        )}
      </label>

      {hasMore && (
        <div className="topbar-more">
          {isAdmin && (
            <>
              <button className="btn btn-quiet" onClick={onCreate} title="Tạo thư mục mới trong thư mục này">
                <IcoFolderPlus size={17} /> <span>Tạo thư mục</span>
              </button>
              <button className="btn btn-quiet" onClick={onUploadFolder} title="Tải cả một thư mục lên">
                <IcoFolderUp size={17} /> <span>Tải thư mục lên</span>
              </button>
            </>
          )}
          {path && (
            <button className="btn btn-quiet" onClick={onDownload} title="Tải file trong thư mục này về máy">
              <IcoDownload size={17} /> <span>Tải về</span>
            </button>
          )}
        </div>
      )}

      {!locked && (
        <button className="btn btn-primary topbar-upload" onClick={onUploadImage} title="Tải ảnh, video hoặc PDF lên thư mục này">
          <IcoUpload size={17} /> <span>Tải lên</span>
        </button>
      )}

      {/* Vạch báo đang tải thư mục, nằm sát mép dưới thanh trên */}
      <span className={`load-bar ${loading ? "on" : ""}`} aria-hidden="true" />
    </header>
  );
}
